// Shared validation for the "new branch name" field used by the category append flows
// (ImportFromPastEventModal + AppendBranchModal). FE mirror of the backend
// Panel\Parameter\Model\ParameterName value object - keep the rules below in sync with it.

// Matches ParameterName::MAX_LENGTH (and the Parameter entity Length(max: 40) constraint).
export const BRANCH_NAME_MAX_LENGTH = 40;
// Matches the ParameterName / Parameter entity Regex constraint and the
// Competitor / academy name convention: markup-relevant characters and the category-path delimiter are rejected,
// so names like "USA Wrestling — 12U, 14U & 16U" and belt slugs like "purple/brown/black"
// are allowed.
export const BRANCH_NAME_VALID_PATTERN = /^[^<>"';]+$/;

/**
 * Returns the translation key of the validation error for the given branch name,
 * or null when the value is valid.
 */
export function branchNameErrorKey(value: string): string | null {
    const trimmed = value.trim();
    if (trimmed.length === 0) {
        return "page.category_manager.append_branch_name_required";
    }
    if (!BRANCH_NAME_VALID_PATTERN.test(trimmed)) {
        return "flash_messages.parameter_cannot_contain_special_characters";
    }
    if (trimmed.length > BRANCH_NAME_MAX_LENGTH) {
        return "flash_messages.parameter_can_have_at_most_40_chars";
    }

    return null;
}
